// extracted by mini-css-extract-plugin
export default {"root":"dVhOIKWrt8EgU1BNlMiC","loadingLink":"q90at3ORnIuuqHk9Y_hA","payLink":"ei_roTFrOZmVXHSI0phR","placeHolderShimmer":"Z3wgVQOsBujMHaLPl3fg"};